import React from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { CondicionPagoService } from '../../../services/CondicionPagoService';
import { Validators } from '../../../components/CatalogForm/validators';

const formFields = [
  {
    name: 'condicion',
    label: 'Clave',
    type: 'text',
    col: 4,
    placeholder: 'Ej. CONTADO',
    validators: [
      Validators.required("La clave es obligatoria")
    ],
  },
  {
    name: 'condicion_nombre',
    label: 'Descripción',
    type: 'text',
    col: 8,
    placeholder: 'Ej. Pago de contado inmediato',
    validators: [
      Validators.required("La descripción es obligatoria")
    ],
  },
];

export const CondicionPagoForm = () => {
  const { id } = useParams();

  const handleLoadData = async (recordId) => {
    return await CondicionPagoService.obtenerPorId(recordId);
  };

  const handleSubmit = async (values) => {
    return await CondicionPagoService.guardar(values);
  };

  return (
    <CatalogForm
      title="Condición de Pago"
      subtitle="Definición de plazos y términos comerciales"
      fields={formFields}
      id={id}
      loadData={handleLoadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/CondicionesPagos"
    />
  );
};

export default CondicionPagoForm;
